const VIDEO_TYPE = "wix-draft-plugin-video";
const VIDEO_TYPE_LEGACY = "VIDEO-EMBED";
const videoButtonsTypes = { video: "video", soundCloud: "soundCloud", youTube: "youTube" };
const mediaTypes = [videoButtonsTypes.soundCloud, videoButtonsTypes.youTube];

export { VIDEO_TYPE, VIDEO_TYPE_LEGACY, mediaTypes, videoButtonsTypes };
//# sourceMappingURL=types.js.map
